<template>
    <v-dialog v-model="dialog" max-width="670" :fullscreen="$vuetify.breakpoint.xs">
        <v-card class="py-8 px-11">
            <ValidationObserver ref="form" v-slot="{ handleSubmit }">
                <v-form @submit.prevent="handleSubmit(save)">
                    <h2 class="text-center">Create Lesson</h2>

                    <ValidationProvider name="Title" rules="required|max:80" v-slot="{ errors }">
                        <v-text-field label="Title"
                                      v-model="lesson.title"
                                      class="mt-5"
                        >
                            <template v-slot:prepend-inner>
                                <svg v-svg="'icon-title'" size="15" class="mr-1"></svg>
                            </template>
                        </v-text-field>
                        <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                    </ValidationProvider>

                    <ValidationProvider name="Description" rules="required" v-slot="{ errors }">
                        <ckeditor :editor="editor"
                                  v-model="lesson.description"
                                  :config="editorConfig"
                                  class="mt-5"
                        ></ckeditor>
                        <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                    </ValidationProvider>

                    <v-card-actions class="d-flex justify-center mt-6">
                        <v-btn class="green white--text mr-4" type="submit" :loading="loadingRequest">Save</v-btn>
                        <v-btn class="transparent green--text ml-4" @click="dialog = false">Close</v-btn>
                    </v-card-actions>
                </v-form>
            </ValidationObserver>
        </v-card>
    </v-dialog>
</template>

<script>
    import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
    export default {
        data(){
            return {
                dialog: false,
                loadingRequest: false,
                lesson: { subject_id: this.$route.query.subject_id },
                editor: ClassicEditor,
                editorConfig: {},
            }
        },

        methods: {
            save() {
                this.loadingRequest = true;
                this.$apiAdmin('lessons').create(this.lesson)
                    .then(() => {
                        this.lesson = { subject_id: this.$route.query.subject_id };
                        this.$refs.form.reset();
                        this.dialog = false;
                        this.$parent.$emit('getLessons');
                        this.$store.dispatch('alert', {type: 1, message: 'Successfully created.'});
                    }).catch((err) => {
                    if (err.response.status === 422) console.log(err.response.data);
                }).finally(() => {
                    this.loadingRequest = false;
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../scss/components/dialog";
</style>